module.exports = __webpack_public_path__ + "images/fcd0f9f8c2ec680367f0db7a0945a398.png";